import apis from "../../../utils/apis";

export const findLawyers = (caseId: string, additionalDetails: { budget: string; timeframe: string }) => async (dispatch: any) => {
    try {
      const response = await apis.post('/cases/find_lawyers', {
        CaseID: caseId,
        ...additionalDetails,
      });
      return response.data.recommended_lawyers || [];  
    } catch (error) {
      throw error;
    }
  };
  
  export const getRecommendedLawyers = (caseId: string) => async (dispatch: any) => {
    try {
      const response = await apis.post('/cases/get_recommended_lawyers', { CaseID: caseId });
      return response.data.recommended_lawyers || [];
    } catch (error) {
      throw error;
    }
  };
